import { getLocateText, oddsKeyArray, locateKeys } from '../oddsKeyArray'
const locateKeyArray = locateKeys.slice(0, 3)

const initDesignated = () => {
  const mainKey = 'designated'
  const keyObj = {}

  locateKeyArray.forEach((item, index) => {
    for (let j = 0; j <= 9; j++) {
      const groupKey = getLocateText(j, index + 1)
      keyObj[groupKey] = {
        mainKey,
        supKey: item,
        groupKey
      }
    }
  })

  return keyObj
}

const initTwoSide = () => {
  const mainKey = 'two_side'
  const twoSideSumKey = groupKey => {
    return {
      mainKey,
      supKey: 'two_side_sum',
      groupKey
    }
  }
  const locateKey = (supKey, groupKey) => {
    return {
      mainKey,
      supKey,
      groupKey
    }
  }
  const includesPrimeAndCompo = [...oddsKeyArray, 'PRIME', 'COMPO']
  let groupKey = ''

  return includesPrimeAndCompo.reduce((root, oddsKey) => {
    if (
      oddsKey === 'PRIME' ||
      oddsKey === 'COMPO' ||
      oddsKey === 'OVER' ||
      oddsKey === 'UNDER'
    ) {
      groupKey = `ALL:SUM:TAIL:${oddsKey}`
      root[groupKey] = twoSideSumKey(groupKey)
    }

    if (oddsKeyArray.includes(oddsKey)) {
      groupKey = `ALL:SUM:${oddsKey}`
      root[groupKey] = twoSideSumKey(groupKey)
    }

    locateKeyArray.forEach((supKey, index) => {
      const numIndex = index + 1
      groupKey = `${numIndex}:${oddsKey}`
      root[groupKey] = locateKey(supKey, groupKey)
    })

    return root
  }, {})
}

const initSum = () => {
  const keyObj = {}

  for (let i = 0; i <= 27; i++) {
    const groupKey = `ALL:SUM:${i}`
    keyObj[groupKey] = {
      mainKey: 'sum',
      supKey: '',
      groupKey
    }
  }

  return keyObj
}

const initGroupSelect = () => {
  const mainKey = 'group_select'
  const keyObj = {
    'CHOOSE:1:MATCH:1': {
      mainKey,
      supKey: 'set_one_get_one'
    },
    'CHOOSE:2:MATCH:2': {
      mainKey,
      supKey: 'set_two_get_two'
    },
    'CHOOSE:3:MATCH:3': {
      mainKey,
      supKey: 'set_three_get_three'
    },
    'TOP:2:PAIR': {
      mainKey,
      supKey: 'front_two'
    },
    'TOP:2:DIFF': {
      mainKey,
      supKey: 'front_two'
    },
    'LAST:2:PAIR': {
      mainKey,
      supKey: 'last_two'
    },
    'LAST:2:DIFF': {
      mainKey,
      supKey: 'last_two'
    }
  }

  for (let i = 4; i <= 10; i++) {
    if (i >= 5 && i <= 10) {
      keyObj[`${i}:PAIR`] = {
        mainKey,
        supKey: 'group_three'
      }
    }
    if (i >= 4 && i <= 8) {
      keyObj[`${i}:DIFF`] = {
        mainKey,
        supKey: 'group_six'
      }
    }
  }

  return keyObj
}

const initDirect = () => {
  const mainKey = 'direct'

  return {
    'TOP:3:MATCH:ORDER:3': {
      mainKey,
      supKey: 'set_three_all_num'
    },
    'TOP:2:MATCH:ORDER:2': {
      mainKey,
      supKey: 'top_two_direct'
    },
    'LAST:2:MATCH:ORDER:2': {
      mainKey,
      supKey: 'last_two_direct'
    }
  }
}

const initCross = () => {
  const keyObj = {}

  for (let i = 0; i <= 9; i++) {
    const groupKey = `${i}:SPAN`
    keyObj[groupKey] = {
      mainKey: 'cross',
      supKey: '',
      groupKey
    }
  }

  return keyObj
}

export default {
  ...initDesignated(),
  ...initSum(),
  ...initTwoSide(),
  ...initGroupSelect(),
  ...initDirect(),
  ...initCross()
}
